<template>
  <footer>
    <div class="grid grid-cols-12" id="kontakt">

      <!-- Kontakt (unverändert) -->
      <div class="m-4 md:m-0 col-span-12 col-start-1 sm:col-start-2 md:col-start-2 md:col-span-4 lg:col-span-4 lg:col-start-3">
        <h3>
          <font-awesome-icon class="mr-2" :icon="['fas', 'address-card']" />
          Kontakt
        </h3>
        <p>
          <font-awesome-icon class="mr-2" :icon="['fas', 'location-dot']" />
          Hauptstraße 226 | 53842 Troisdorf
        </p>
        <p>
          <font-awesome-icon class="mr-2" :icon="['fas', 'envelope']" />
          <a href="mailto:kontakt@lautstark-wagner.de">kontakt@lautstark-wagner.de</a>
        </p>
        <p>
          <font-awesome-icon class="mr-2" :icon="['fas', 'phone']" />
          02241 / 8468777
        </p>
      </div>

      <!-- RECHTE SEITE (aufgeteilt) -->
      <div class="m-4 md:m-0 col-span-12 col-start-1 sm:col-start-2 md:col-start-7 lg:col-span-4 lg:col-start-7">

        <!-- inneres grid -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-start">

          <!-- Rechtliches -->
          <div>
            <h3>
              <font-awesome-icon class="mr-2" :icon="['fas', 'scale-balanced']" />
              Rechtliches
            </h3>
            <p class="links">
              <router-link to="/datenschutz">Datenschutzerklärung</router-link>
            </p>
            <p class="links">
              <router-link to="/impressum">Impressum</router-link>
            </p>
          </div>

          <!-- Logo -->
          <div class="flex lg:justify-end items-center md:items-start">
            <img
                alt="DBL - Deutscher Bundesverband für Logopädie e.V."
                class="logo sm:max-w-[30%] md:max-w-[80%]"
                src="@/assets/logo_dbl.png"
            />
          </div>

        </div>
      </div>

      <!-- Copyright -->
      <div class="col-span-12 text-center">
        <p class="copyright">
          {{ new Date().getFullYear() }} © Lautstark Logopädie Romy Wagner
        </p>
      </div>

    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped lang="scss">
footer {
  background-color: $color-grey;
  color: white;
  padding-top: $spacing-l;

  h3 {
    margin-bottom: $spacing-l;
    font-size: $font-size-larger;
    font-weight: $font-weight-largest;
  }

  p {
    margin: $spacing-s 0;
    color: white;
  }

  .links {
    a {
      color: white;
      font-weight: $font-weight-smallest;
      margin: $spacing-s 0;
    }
  }
  .copyright {
    font-size: $font-size;
  }
}
</style>